import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/option_detail.js';
import { shareColumnsExtend } from './share';
const filterColumns = {
  type_eq: {
    column_type: 'type',
    extra: {
      options: [],
    },
    model_name: 'Option',
    column_name: 'type',
  },
  name_cont: {
    model_name: 'Option',
    column_type: 'string',
    column_name: 'name',
  },
}
export const formColumnsConfig = {
  'self': {
    'type': { required: true, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'cover': { required: false, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
    'prompt': { required: false, disabledUpdate: false },
    'guidance_scale': { required: false, disabledUpdate: false },
    'negative_prompt': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Option', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Option', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
